import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
	selector: 'tr[app-file-list-view]',
	templateUrl: './file-list-view.component.html',
	styleUrls: ['./file-list-view.component.scss']
})
export class FileListViewComponent {
	@Input() fileData;
	@Input() allowedDimensions;
	@Input() isPopup;
	@Input() type;
	@Input() public indexNumber: number;
	@Output() output = new EventEmitter();
	showToolbar;

	constructor() {}

	deleteFile(fileName: string, event = null): void {
		this.output.emit({ method: 'delete', fileName: fileName });

		if (event) {
			event.stopPropagation();
		}
	}

	editFile(file): boolean {
		this.output.emit({ method: 'edit', file: file });
		return false;
	}

	isEditDisabled() {
		let isRequiredDimensions = false;
		let isDimensionsNotEqual = false;
		const isImage: boolean = this.fileData.fileType === `image`;
		if (isImage) {
			isRequiredDimensions = this.allowedDimensions;
			isDimensionsNotEqual = this.allowedDimensions !== `${this.fileData.dimensions[0]}x${this.fileData.dimensions[1]}`;
		}

		return Boolean(this.isPopup && isImage && isRequiredDimensions && isDimensionsNotEqual);
	}

	selectFile() {
		if (this.isEditDisabled()) {
			this.output.emit({ method: 'edit', file: this.fileData });
		} else {
			this.output.emit({ method: 'selected', fileName: this.fileData.oldPath });
		}
	}
}
